import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import home_images from '../../assets/images/home/*.svg'

export default class TrainPositionsFooter extends React.Component {
  static propTypes = {
    lineName: PropTypes.string.isRequired,
    notifications: PropTypes.array.isRequired,
    themeName: PropTypes.string.isRequired
  }

  static contextTypes = {
    intl: PropTypes.object
  }

  renderNote() {
    return (
      <div className="c-Footer-note">
        <p className="c-Footer-noteTitle">運行情報通知</p>
        <ul className="c-Footer-noteNav">
          <li className="c-Footer-noteNavItem">
            <a href="https://www.traffic.nankai.co.jp/railinfo/01.html">詳細</a>
          </li>
          <li className="c-Footer-noteNavItem">
            <a href="https://www.traffic.nankai.co.jp/delay/">遅延証明書</a>
          </li>
        </ul>
        <p>只今、運行情報があります。</p>
      </div>
    )
  }

  render() {
    const {notifications} = this.props
    const image_url = "home_nosignal"
    var delay_info = notifications.some(notification => notification.delay === true)

    return (
      <footer className="c-Footer">
        <div className="c-Footer-description">
          <img src={home_images[image_url]} />
        </div>
        {delay_info ? this.renderNote() : "" }
      </footer>
    )
  }
}
